export { toSentenceCase, type SentenceCaseOptions } from "./sentence-case";
